export const iconFontAwesomeMedicalHealthHeadSideCoughSlash = (
	<i className="fa-solid fa-head-side-cough-slash"></i>
);
